import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { catchError, of, take } from 'rxjs';
import { DocksModel } from 'src/app/models/DocksModel';
import { ReceivingService } from 'src/app/services/receiving/receiving.service';

@Component({
  selector: 'app-view-rec',
  templateUrl: './view-rec.component.html',
  styleUrl: './view-rec.component.css'
})
export class ViewRecComponent {
  constructor(private router: Router,
    private recService: ReceivingService) { }

  config: boolean = false;
  dateInterval: any
  updateInterval: any
  recDocks: DocksModel[] = []
  dockId!: number
  selectedDock: number | any
  faFilter = faFilter

  ngOnInit() {
    this.updateData();
    this.dateInterval = setInterval(() => {
      this.updateData();
    }, 5000);
  }

  updateData(): void {
    this.recService.getRecDocksData().pipe
      (take(1),
        catchError(() => {
          return of({ recDocks: [] })
        })
      ).subscribe(
        (response) => {
          this.recDocks = response.recDocks.map(d => ({
            ...d,
            status: new Date(d.status + 'Z')
          }))
            .sort((a, b) => {
              const numA = parseInt(a.description!.replace(/\D/g, ''), 10)
              const numB = parseInt(b.description!.replace(/\D/g, ''), 10)
              return numA - numB
            })
            ;
        }
      )
  }

  changeDockPage() {
    if (this.selectedDock !== null) {
      // Fecha o modal e redireciona para o componente TripDetailsComponent
      this.config = false;
      this.router.navigate([`/view/rec/dock/${this.selectedDock}`]);
    }
  }
}
